import React, { useEffect } from "react";
import footerImageZeppoli from "../assets/img/footerImageZeppoli.webp";
import xpertlab_logo from "../assets/img/XpertLab.webp";
import { Link } from "react-router-dom";

function Footer() {
  /*---------- 05. Scroll To Top ----------*/
  // progressAvtivation
  useEffect(() => {
    const scrollTopBtn = document.querySelector(".scroll-top");
    const progressPath = document.querySelector(".scroll-top path");
    const pathLength = progressPath.getTotalLength();
    progressPath.style.transition = "none";
    progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
    progressPath.style.strokeDashoffset = pathLength;
    progressPath.getBoundingClientRect();
    progressPath.style.transition = "stroke-dashoffset 10ms linear";

    const updateProgress = () => {
      const scrollValue = window.scrollY || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - window.innerHeight;
      const progress = pathLength - (scrollValue * pathLength) / height;
      progressPath.style.strokeDashoffset = progress;
    };

    updateProgress();
    window.addEventListener("scroll", updateProgress);

    const offset = 50;
    const duration = 750;

    const handleScroll = () => {
      if (window.scrollY > offset) {
        scrollTopBtn.classList.add("show");
      } else {
        scrollTopBtn.classList.remove("show");
      }
    };

    window.addEventListener("scroll", handleScroll);

    const handleClick = () => {
      const startTime = performance.now();
      const startScroll = window.scrollY || document.documentElement.scrollTop;

      const animateScroll = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const easeInOutQuart = (t) =>
          t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
        const scrollValue =
          startScroll + easeInOutQuart(progress) * (0 - startScroll);
        window.scrollTo(0, scrollValue);

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    };

    scrollTopBtn.addEventListener("click", handleClick);

    // Cleanup the event listeners on component unmount
    return () => {
      window.removeEventListener("scroll", updateProgress);
      window.removeEventListener("scroll", handleScroll);
      scrollTopBtn.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <>
      {/* <!--==============================
	Footer Area
==============================--> */}
      {/* <div className="" data-pos-for=".footer-wrapper"  data-sec-pos="bottom-half">
        <div className="container">
            <div className="newsletter-wrap space" style={{backgroundImage:`url(${subscribe_bg_1})`}} data-bg-src={subscribe_bg_1}>
                <h2 className="sec-title mb-10 fw-semibold">Subscribe to our newsletter</h2>
                <p className="mb-20">Get updates for new products</p>
                <form className="newsletter-form">
                    <input className="form-control" type="email" placeholder="Enter Email Address" required="" />
                    <button type="submit" className="th-btn">SUBCRIBE<i className="fas fa-arrow-right ms-2"></i></button>
                </form>
            </div>
        </div>
    </div> */}
      <footer
        className="footer-wrapper footer-layout2"
        // style={{backgroundImage:`url(${footer_bg_2})`}}
        data-bg-src={footerImageZeppoli}
      >
        <div className="widget-area">
          <div className="container">
            <div className="row justify-content-around">
              <div className="col-md-6 col-xl-auto">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">Quick Links</h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/about">About Us</Link>
                      </li>
                      <li>
                        <Link to="/catalogs">Catalogs</Link>
                      </li>
                      <li>
                        <Link to="/location">Location</Link>
                      </li>
                      <li>
                        <Link to="/career">Career</Link>
                      </li>
                      <li>
                        <Link to="/gallery">Gallery</Link>
                      </li>
                      <li>
                        <Link to="/franchise">Franchise</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact Us</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-3">
                <div className="widget footer-widget">
                  <h3 className="widget_title">About Zeppoli Bakers</h3>
                  <div className="th-widget-about">
                    <p className="about-text">
                      Zeppoli Bakers’ is a leading bakery factory based in the
                      scenic town of Dhoraji in the Saurashtra region.{" "}
                    </p>
                    <div className="th-social">
                      <Link
                        to="https://www.facebook.com/"
                        target="_blank"
                        name="Zeppoli facebook icon"
                        aria-label="Zeppoli facebook icon"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </Link>
                      {/* <Link to="https://www.twitter.com/" target="_blank">
                        <i className="fab fa-twitter"></i>
                      </Link>
                      <Link to="https://www.linkedin.com/" target="_blank">
                        <i className="fab fa-linkedin-in"></i>
                      </Link> */}
                      <Link
                        to="https://www.instagram.com/zeppoli_foods_official/"
                        name="Zeppoli instagram icon"
                        target="_blank"
                        aria-label="Zeppoli instagram icon"
                      >
                        <i className="fab fa-instagram"></i>
                      </Link>
                      <Link
                        to="https://www.whatsapp.com/"
                        target="_blank"
                        name="Zeppoli whatsapp icon"
                        aria-label="Zeppoli whatsapp icon"
                      >
                        <i className="fab fa-whatsapp"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-auto">
                <div className="widget footer-widget">
                  <h3 className="widget_title">Contact Now</h3>
                  <div className="th-widget-contact">
                    <div className="info-box">
                      <div className="info-box_icon mt-">
                        <i className="fal fa-location-dot"></i>
                      </div>
                      <p className="info-box_text">
                        (589/3/P3/P3) Near Bhola Patiya Old Upleta Road,
                        Dhoraji, Dist. Rajkot Gujarat - 360410
                      </p>
                    </div>
                    <div className="info-box">
                      <div className="info-box_icon">
                        <i className="fal fa-mobile-button"></i>
                      </div>
                      <p className="info-box_text pt-2">
                        <Link to="tel:+919978232123" className="info-box_link">
                          (+91) 99782 32123
                        </Link>
                      </p>
                    </div>
                    <div className="info-box">
                      <div className="info-box_icon">
                        <i className="fal fa-envelope"></i>
                      </div>
                      <p className="info-box_text pt-2">
                        <Link
                          to="mailto:zeppolifoods123@gmail.com"
                          className="info-box_link"
                        >
                          zeppolifoods123@gmail.com
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrap">
          <div className="container">
            <div
              className="row justify-content-between align-items-center"
              style={{ textAlign: "center" }}
            >
              <div className="col-lg-12">
                <p className="copyright-text">
                  <span>&copy;{new Date().getFullYear().toString()}</span>
                  <span>
                    {" "}
                    <a
                      href="https://zeppoli.in/"
                      target="_blank"
                      name="zeppoli website link"
                      aria-label="Zeppoli website link"
                    >
                      Zeppoli Bakers
                    </a>{" "}
                    All Rights Reserved.{" "}
                  </span>
                  <span>
                    Designed & Developed By{" "}
                    <Link to="https://xpertlab.com/" target="_blank">
                      <img
                        src={xpertlab_logo}
                        alt="Xpertlab logo"
                        srcSet={`${xpertlab_logo} 300w,
                          ${xpertlab_logo} 500w,
                          ${xpertlab_logo} 1000w,
                          ${xpertlab_logo} 2000w`}
                        width={"70px"}
                        height={"70px"}
                      />
                    </Link>
                  </span>
                </p>
              </div>
              {/* <div className="col-lg-6 text-end d-none d-lg-block">
                        <div className="footer-links">
                            <ul>
                                <li><Link to="about.html">Privacy Policy</Link></li>
                                <li><Link to="about.html">Terms & Condition</Link></li>
                            </ul>
                        </div>
                    </div> */}
            </div>
          </div>
        </div>
      </footer>

      {/* <!--********************************
			Code End  Here 
	******************************** --> */}

      {/* <!-- Scroll To Top --> */}
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  );
}

export default Footer;
